import { User } from "@/types/user";
import { Card, CardFooter, CardHeader, Chip } from "@heroui/react";
import {
    formatAccountType,
    getOrgName,
} from "@/components/network/networkUtils";

type MobileUserCardProps = {
    user: User;
    onPress?: () => void;
};

function getAccountTypeColor(
    type?: string,
): "primary" | "secondary" | "default" {
    if (type === "sentinel") return "primary";
    if (type === "consultant") return "secondary";
    return "default";
}

export default function MobileUserCard({ user, onPress }: MobileUserCardProps) {
    const orgName = getOrgName(user.organization);
    const displayName = user.full_name || user.username;

    return (
        <Card
            isPressable={!!onPress}
            onPress={onPress}
            className="w-full hover:bg-gray-200"
            shadow="sm"
        >
            <CardHeader className="pb-1 px-3">
                <div className="flex w-full items-start justify-between gap-2 text-left">
                    <div className="flex flex-1 flex-col items-start min-w-0 text-left">
                        <p className="w-full text-left font-semibold text-lg truncate">
                            {displayName}
                        </p>

                        {user.full_name && (
                            <p className="w-full text-left text-sm truncate">
                                {user.username}
                            </p>
                        )}
                    </div>

                    <Chip
                        size="sm"
                        radius="sm"
                        variant="flat"
                        color={user.is_active ? "success" : "danger"}
                        className="shrink-0"
                    >
                        {user.is_active ? "Active" : "Inactive"}
                    </Chip>
                </div>
            </CardHeader>

            <CardFooter className="text-xs pt-0 px-3">
                <div className="flex flex-row justify-between w-full items-center gap-2">
                    <Chip
                        size="sm"
                        radius="sm"
                        variant="flat"
                        color={getAccountTypeColor(user.account_type)}
                        className="shrink-0"
                    >
                        {formatAccountType(user.account_type)}
                    </Chip>

                    {orgName && (
                        <div className="text-right shrink-0 max-w-[65%] truncate">
                            {orgName}
                        </div>
                    )}
                </div>
            </CardFooter>
        </Card>
    );
}
